import { lazy } from 'react';

export * from './SpaceSelect';

export const GlobalSpaceSelect = lazy(() =>
  import(/* webpackChunkName: "GlobalSpaceSelect" */ './GlobalSpaceSelect').then((module) => ({
    default: module.GlobalSpaceSelect,
  }))
);
